'use strict';

DoohApps
    .factory('Campaign', ['restApi', function (restApi) {
        var controllerName = 'Campaign/';

        return {
            getCampaignList: function (successCallback, objectFilterOptions) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetCampaignList', objectFilterOptions);
            },
            getLatestApps: function (successCallback, QuickApp) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetLatestApps?ResultCount=' + QuickApp.Count + '&companyId=' + QuickApp.companyId + '&search=' + QuickApp.Text);
            },
            updateCampaign: function (successCallback, campaign) {
                restApi.PutApiMethod(successCallback, controllerName + 'PutCampaign', campaign);
            },
            deleteCampaign: function (successCallback, Id) {
                restApi.DeleteApiMethod(successCallback, controllerName + 'DeleteCampaign?Id=' + Id);
            },
            updateCampaignConfiguration: function (successCallback, campaign) {
                restApi.PutApiMethod(successCallback, controllerName + 'UpdateCampaignConfiguration', campaign);
            },
            generateCampaignUniqueCode: function (successCallback, campaignId) {
                restApi.GetApiMethod(successCallback, controllerName + 'GenerateCampaignUniqueCode?campaignId=' + campaignId);
            },
            addCampaignToAppInbox: function (successCallback, campaignCode, FolderId) {
                restApi.PostApiMethod(successCallback, controllerName + 'AddCampaignToAppInbox?campaignCode=' + campaignCode + '&FolderId=' + FolderId);
            },
            createCampaign: function (successCallback, campaign) {
                restApi.PostApiMethod(successCallback, controllerName + 'CreateCampaign', campaign);
            },
                        
            getCampaignEvents: function (successCallback, objectFilterOptions) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetCampaignEvents', objectFilterOptions);
            },
            isCampaignRunning: function (successCallback, campaignId) {
                restApi.GetApiMethod(successCallback, controllerName + 'IsCampaignRunning?Id=' + campaignId);
            },
            rateYourApplication: function (successCallback, rate) {
                restApi.PostApiMethod(successCallback, controllerName + 'RateYourApplication', rate);
            },
            shareConfiguration: function (successCallback, data) {
                restApi.PostApiMethod(successCallback, controllerName + 'ShareConfiguration', data);
            },
            duplicateCampaignLocally: function (successCallback, campaignID) {
                restApi.PostApiMethod(successCallback, controllerName + 'DuplicateLocally?campaignID=' + campaignID);
            },
            getCampaignByCode: function (successCallback, campaignCode) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetCampaignByCode?campaignCode=' + campaignCode);
            },
            getCampaignAssetFiles: function (successCallback, objParam) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetCampaignAssetFiles?campaignCode=' + objParam.CampaignCode + '&Offset=' + objParam.Offset + '&Count=' + objParam.Count);
            },
            prepareCampaignUpgrade: function (successCallback, id) {
                restApi.GetApiMethod(successCallback, controllerName + 'PrepareCampaignUpgrade?CampaignID=' + id);
            },
            doCampaignUpgrade: function (successCallback, campaignInfo) {
                restApi.PostApiMethod(successCallback, controllerName + 'DoCampaignUpgrade', campaignInfo);
            },
            getCampaignpage: function (successCallback, id,count) {
                restApi.GetApiMethod(successCallback, controllerName + 'getCampaignpage?campaignID=' + id + '&itemsCount=' + count);
            },
            getCustomScript: function (successCallback, id) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetCustomScript?AppVerID=' + id);
            },
            getCampaignConfigInfo: function (successCallback, data) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetCampaignConfigInfo', data);
            },
            extendCampaignCodeDuration: function (successCallback, campaignID) {
                restApi.GetApiMethod(successCallback, controllerName + 'ExtendCampaignCodeDuration?campaignID=' + campaignID);
            }
        }
    }])
    .factory('CampaignDataFilter', ['$http', '$q', 'DoohConfig', function ($http, $q, DoohConfig) {
        //Filter options to campign/////
        var DataFilter = {};
        DataFilter.SetDefault = function () {
            DataFilter.AppInboxFilter = {};
            DataFilter.AppInboxFilter.Offset = 0;
            DataFilter.AppInboxFilter.Count = 6;
            DataFilter.AppInboxFilter.Desc = false;
            DataFilter.AppInboxFilter.IsArchived = false;
            DataFilter.AppInboxFilter.Text = ''
            DataFilter.AppInboxFilter.CompanyName = ''
            DataFilter.AppInboxFilter.CreatedBy = 0
            DataFilter.AppInboxFilter.licenceOrder = 0
            DataFilter.AppInboxFilter.nameOrder = 0
            DataFilter.AppInboxFilter.userOrder = 0
            DataFilter.AppInboxFilter.dateOrder = 2
            DataFilter.AppInboxFilter.TotalCount = 0;
            DataFilter.AppInboxFilter.archived = false;
            DataFilter.SelectedApplication = {};
            DataFilter.ConfigureCampaign = '';
            DataFilter.SelectedCampaign = {};
            DataFilter.SelectedScreen = {};
            DataFilter.SelectedSchedule = {};
            DataFilter.SelectedCampaign.ApplicationID = null;
            DataFilter.Campaigns = new Array();

            DataFilter.SchedulerApplicationFilter = {}
            DataFilter.SchedulerApplicationFilter.Count = 6;
            DataFilter.SchedulerApplicationFilter.Offset = 0;
            DataFilter.SchedulerApplicationFilter.TotalCount = 0;

            DataFilter.StartScheduleByScreen = false;
        }

        DataFilter.SetDefault();

        DataFilter.Clear = function () {
            DataFilter.SetDefault();
        }

        DataFilter.prepSelectedApplication = function (that) {
            this.SelectedApplication = that;
        }

        DataFilter.prepConfigureCampaign = function (that) {
            this.ConfigureCampaign = that;
        }

        DataFilter.prepSelectedScreen = function (that) {
            this.SelectedScreen = that;
        }

        DataFilter.prepCampiagns = function (that) {
            this.Campaigns = that;
        }

        DataFilter.prepSelectedCampgin = function (that) {
            this.SelectedCampaign = that;
        }

        DataFilter.prepSelectedSchedule= function (that) {
            this.SelectedSchedule = angular.copy(that);
            this.SelectedSchedule.start = moment(this.SelectedSchedule.start);
            this.SelectedSchedule.end = moment(this.SelectedSchedule.end);
            this.SelectedSchedule.ScheduleID = this.SelectedSchedule.ScheduleId;

        }

        DataFilter.loadConfiguration = function (callback) {

            angular.forEach(DataFilter.SelectedApplication.ConfigBlocks, function (blockVal) {
                var found = false;

                angular.forEach(DataFilter.SelectedApplication.AppConfigurations, function (configVal) {
                    if (blockVal.BlockID == configVal.BlockID) {
                        blockVal.ConfigurationValue = configVal.ConfigurationValue;
                        found = true;
                    }
                });

                if (!found) {
                    DataFilter.SelectedApplication.AppConfigurations.push({
                        ConfigurationName: blockVal.Label,
                        BlockID: blockVal.BlockID,
                        ConfigurationValue: blockVal.DefaultValue
                    });
                    blockVal.ConfigurationValue = blockVal.DefaultValue;
                }

            });
            callback();
        }

        DataFilter.ConfiguratorBlocks = [];
        DataFilter.setConfiguratorBlocks = function (callback) {
            if (DataFilter.ConfiguratorBlocks.length == 0) {
                $q.all([
                      $http.get('Templates/Partials/Configurator/blocks/blockWrapper.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/Checkbox.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/colorVideImagePicker.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/effectSelect.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/effectColor.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/positioning.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/singleSelect.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/Slider.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/colVidImgPickerWithAttachments.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/textInput.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/region.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/WebAppPreview.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/Hidden.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/simpleMediaPicker.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/jsonEditor.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/mediaList.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/multiSelect.html?v=' + DoohConfig.version),
                      $http.get('Templates/Partials/Configurator/blocks/textBlock.html?v=' + DoohConfig.version)
                ]).then(function (returnValues) {
                    DataFilter.ConfiguratorBlocks = returnValues;
                    callback();
                });
            } else {
                callback();
            }

        }

        return DataFilter;
    }]);
